import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Table,
  OffcanvasHeader,
  Offcanvas,
  OffcanvasBody,
} from "reactstrap"
import { connect } from "react-redux"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import { getCampaign } from "../../store/campaign/actions"
//i18n
import { withTranslation } from "react-i18next"
import { isEmpty, map, size } from "lodash";
import DashboardChart from "./charts/dashboard-chart";
import CampaignSidebar from "components/VerticalLayout/CampaignSidebar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Moment from "react-moment";
import ActionEdit from "components/buttons/actionEdit";
import ActionDelete from "components/buttons/actionDelete";
import ActionResend from "components/buttons/actionResend";
import ActionAnalytics from "components/buttons/actionAnalytics";
import axios from "axios";
import { API_URL } from "helpers/app_url";
import Swal from 'sweetalert2';
import { Tbody, Td, Th, Tr } from "react-super-responsive-table";
class CreateComp extends Component {
  constructor(props) {
    super(props);
  this.state = {
       
      }
       this.toggleReportCanvas = this.toggleReportCanvas.bind(this);
  }
 reporttoggle() {
    this.setState(prevState => ({
      isReportRight: !prevState.isReportRight
    }));
  }
  toggleReportCanvas() {
    this.setState({ report: "", isReportRight: !this.state.isReportRight });
    this.reporttoggle();
  }
   toggleReportCanvas = arg => {
    const report = arg;
    this.setState({
      report: {
        id:report.id,
      
      },
     
    });
    this.fetchReport(report.id);
    this.reporttoggle();
  };
  fetchReport(id) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj?.resultData?.bearerToken;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
  
      const params = {
        Id: id,
      };
      axios
        .get(`${API_URL}AgentEmailCampaign/AgentEmailCampaignstats`, { headers, params })
        .then((response) => {
          this.setState({ reportsData: response.data, loading: false });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
  fetchAllCamp(){
          const obj = JSON.parse(localStorage.getItem("authUser"));
          const token = obj.resultData.bearerToken;
          const str = 'Bearer ' + token;
          axios.get(API_URL + 'AgentEmailCampaign/allAgentEmailCampaigns', {
            params: {
              agentId: localStorage.getItem('userId'),
            },
            headers: { Authorization: str }
          })
            .then(res => {
              const campaigns = res.data;
              this.setState({ campaigns });
            })
            .catch(error => {
             
              console.error('Error fetching data:', error);
            })
          
  }

  componentDidMount() {
   this.fetchAllCamp();
  }
 deleteList = (rowData) => {
   Swal.fire({
     title: 'Are you sure?',
     text: 'This action will delete the campaign. You won’t be able to revert this!',
     icon: 'warning',
     showCancelButton: true,
     confirmButtonColor: '#d33',
     cancelButtonColor: '#3085d6',
     confirmButtonText: 'Yes, delete it!'
   }).then((result) => {
     if (result.isConfirmed) {
       const id = rowData.id;
       const obj = JSON.parse(localStorage.getItem("authUser"));
       const token = obj?.resultData?.bearerToken;
 
       fetch(`${API_URL}AgentEmailCampaign/DeleteDraftAgentEmailCampaign?id=${id}`, {
         method: 'DELETE',
         headers: {
           'Content-Type': 'application/json',
           'Authorization': `Bearer ${token}`
         },
       })
         .then((response) => {
           if (!response.ok) throw new Error('Failed to delete campaign');
           return response.json();
         })
         .then((data) => {
           if (data.success) {
              const campaigns = this.state.campaigns.filter(c => c.id !== id);
             this.setState({ campaigns });
             Swal.fire('Deleted!', 'The campaign has been deleted.', 'success');
            
           } else {
             Swal.fire('Failed!', data.message || 'Delete failed.', 'error');
           }
         })
         .catch((error) => {
           console.error('Delete error:', error);
           Swal.fire('Error!', 'Something went wrong.', 'error');
         });
     }
   });
 };

  handleResend = (rowData) => {
     const id = rowData.id;
     const obj = JSON.parse(localStorage.getItem("authUser"));
     const token = obj.resultData.bearerToken;
 
     fetch(`${API_URL}AgentEmailCampaign/resendAgentEmailCampaign?Id=${id}`, {
       method: 'GET',
       headers: {
         'Content-Type': 'application/json',
         'Authorization': `Bearer ${token}`,
       },
     })
       .then((response) => {
         if (!response.ok) {
           throw new Error('Failed to resend email campaign');
         }
         return response.json();
       })
       .then((data) => {
         if (data.success === true) {
          
           this.props.history.push(`/campaign/mail-send/${data.agentEmailCampaign.id}/${data.agentEmailCampaign.agentEmailCampaignId	}`);
         } else {
         }
       })
       .catch((error) => {
         console.error('Resend error:', error);
       });
   };
  render() {
    const { reportsData } = this.state;
    
    return (
      <React.Fragment>
       
        <div className="page-content project-page-content">
          <MetaTags>
            <title>Create Template | Realty Space</title>
          </MetaTags>
          <Container fluid className="ps-0">
            {/* Render Breadcrumb */}
            <Row>
              <Col sm='2' className="pe-0">
              <CampaignSidebar  />
              </Col>
              <Col sm='10' className="ps-0 pe-0">
              <Row className="project-header">
                <Col sm='7'>
            {/* <Row>
              <Col sm="6"> */}
                <Breadcrumbs
                  title={this.props.t("Campaign")}
                  breadcrumbItem={this.props.t("Dashboard")}
                />
              </Col>
            <Col sm="4" className="pt-4">
                {/* <Link
                  to="/create-campaign"
                  className="btn btn-add btn-md "
                >
                  <i className="mdi mdi-plus-box-outline ms-1" /> {" "} Create New Campaign
                </Link> */}
              </Col>
            </Row>
          
            <Row>
            
            </Row>
            {/* <DashboardChart />   */}
            <Row>
              <Col sm="12">
                
                <Card>
                  <CardBody>
                
          <div className="clearfix"></div>
               <DataTable className="" stripedRows value={this.state.campaigns} paginator rows={5} rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]} currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries " paginatorTemplate=" FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown   " tableStyle={{ minWidth: '50rem' }}   >
                                  <Column
                                                              header="#"
                                                              body={(rowData, options) => options.rowIndex + 1}
                                                              style={{ width: '60px'}}
                                                            />
                                    <Column field="date" header="Date" body={(rowData) => (
                                      <Moment format="D MMM YY">{rowData.createdDate}</Moment>
                                    )}></Column>
                                    <Column field="title" header="Title" body={(rowData) => (
                                      rowData.emailCampaignTitle || 'N/A'
                                    )}></Column>
                                     <Column  field="emailCampaignTypeTitle" header="Type">  </Column>
                                    <Column field="target" header="Target" body={(rowData) => (
          
                                      rowData.emailCampaignTargetTypeTitle ? rowData.emailCampaignTargetTypeTitle + "-" + rowData.emailCampaignTargetTypeSubTitle : 'N/A'
                                    )}></Column>
                                    <Column field="template" header="Theme" body={(rowData) => (
                                      rowData.emailCampaignTemplateTitle || 'N/A'
                                    )}></Column>
                                    <Column  field="type" header="Email Sent">  </Column>
                                    <Column field="status" header="Status" body={(rowData) => (
                                      rowData.emailCampaignPublishStatus
                                    )}></Column>
                                    <Column
                                      field="action"
                                      header="Action"
                                      body={(rowData) => {
                                        const status = rowData.emailCampaignPublishStatus;
          
                                        if (status === 'Draft') {
                                          return (
                                            <>
                                              <ActionEdit to={`/campaign-mails/${rowData.agentEmailCampaignId}/${rowData.id}`} />
                                              <ActionDelete onClick={()=>this.deleteList(rowData)} />
          
                                            </>
                                          );
                                        } else if (status === 'Published') {
                                          return (
                                            <>
                                              <ActionResend onClick={() => this.handleResend(rowData)} />
          
                                              <ActionAnalytics onClick={()=>this.toggleReportCanvas(rowData)} />
                                            </>
                                          );
                                        } else {
                                          return null;
                                        }
                                      }}
                                    />
                                  </DataTable>
              

                  </CardBody>
                </Card>
              </Col>
            </Row>
            </Col>
            </Row>
          </Container>


        </div>
         <Offcanvas
          isOpen={this.state.isReportRight}
          direction="end"
          toggle={this.toggleReportCanvas}
        >
          <OffcanvasHeader toggle={this.toggleReportCanvas}>
            Campaign Report
          </OffcanvasHeader>
          <OffcanvasBody>
                 <Table className="table table-nowrap table-centered">
                 
                  <Tbody>
                   
                    {reportsData && reportsData.map((report, index) => (
                      <Tr key={index}>
                        <Th scope="row">{report.status}</Th>
                        <Td>{report.count}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>                     
          </OffcanvasBody>
        </Offcanvas>
      </React.Fragment>
    )
  }



}


CreateComp.propTypes = {
  t:  PropTypes.any,
  match:PropTypes.object,
  history:PropTypes.object
  

}
const mapStateToProps = ({ campaign }) => (
  {

   
  })
const mapDispatchToProps = dispatch => ({
 
});

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(CreateComp))